import { CommonModule } from '@angular/common';
import {
	Component,
	OnInit,
	Inject,
	Output,
	EventEmitter,
	OnDestroy,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	inject,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
	MatSnackBarRef,
	MatSnackBarConfig,
	MAT_SNACK_BAR_DATA,
} from '@angular/material/snack-bar';

import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { markForCheckOnEmit } from '@jepto/shared/utils/change-detection';
@Component({
	selector: 'jep-snackbar-tpl',
	standalone: true,
	templateUrl: './jep-snackbar.component.html',
	styleUrls: ['./jep-snackbar.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [CommonModule, MatButtonModule],
})
export class JepSnackbarComponent implements OnInit, OnDestroy {
	private readonly cdr = inject(ChangeDetectorRef);
	constructor(
		public snackbarRef: MatSnackBarRef<JepSnackbarComponent>,
		private snackbarConfig: MatSnackBarConfig,
		private router: Router,
		@Inject(MAT_SNACK_BAR_DATA) public data: any
	) {}

	@Output()
	onClickSnackbar = new EventEmitter<any>();

	showButton: boolean = false;
	textButton: string = 'Ok';
	dismiss: boolean = true;
	unsubscribe$ = new Subject<void>();

	ngOnInit() {
		this.routerEvent();

		if (this.data.withButton) {
			this.showButton = true;
		} else {
			// Snackbar is already visible — this only schedules auto-dismiss.
			// `delayMs === null` when duration is 0 (stay open until manual dismiss).
			const delayMs = this.getAutoDismissDelayMs();
			if (delayMs != null) {
				setTimeout(() => {
					if (this.dismiss) {
						this.snackbarRef.dismiss();
					}
					this.cdr.markForCheck();
				}, delayMs);
			}
		}

		this.textButton = this.data.customTextButton
			? this.data.customTextButton
			: this.textButton;
	}

	ngOnDestroy() {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

	mouseEnter() {
		this.dismiss = false;
	}

	mouseLeave() {
		if (!this.data.withButton) {
			const delayMs = this.getAutoDismissDelayMs();
			if (delayMs != null) {
				this.dismiss = true;
				setTimeout(() => {
					if (this.dismiss) {
						this.snackbarRef.dismiss();
					}
					this.cdr.markForCheck();
				}, delayMs);
			}
		}
	}

	/**
	 * Uses snack bar config `duration` from the caller's `openFromComponent` options.
	 * `0` means no auto-dismiss (Material convention). When duration is omitted, keep the
	 * previous implicit 5000ms default used across the app before per-call durations existed.
	 */
	private getAutoDismissDelayMs(): number | null {
		const duration = this.snackbarConfig.duration;
		if (duration === 0) {
			return null;
		}
		if (duration == null) {
			return 5000;
		}
		return duration;
	}

	onClickBtn() {
		this.onClickSnackbar.emit(true);
		this.snackbarRef.dismiss();
		if (Boolean(this.data.path)) {
			if (
				this.data.path.includes('http') ||
				this.data.path.includes('https')
			) {
				window.open(this.data.path, '_blank');
			} else {
				if (this.data.autoCloseDrawer) {
					const body = document.getElementsByTagName('body');
					const overlay =
						document.getElementsByClassName('jep-drawer-overlay');
					overlay[0].classList.remove('show');
					body[0].classList.remove('drawer-open');
				}
				this.router.navigate([this.data.path]);
				console.log('clg body nav', this.data);
			}
		}
	}

	routerEvent() {
		this.router.events
			.pipe(
				filter(event => event instanceof NavigationEnd),
				markForCheckOnEmit(this.cdr),
				takeUntil(this.unsubscribe$)
			)
			.subscribe(event => {
				if (
					event instanceof NavigationEnd &&
					event.url === '/sign-in'
				) {
					this.snackbarRef.dismiss();
				}
			});
	}
}
